import React, { useState } from "react";
import {
  Box,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Chip,
} from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PersonIcon from "@mui/icons-material/Person";

import DriversReportTracker from "./DriversReportTracker/index";

import DeliveryReport from "../DeliveryReport";

const ActionsCell = ({ params }) => {
  const [openTrackDelivery, setOpenTrackDelivery] = useState(false);
  const [openDeliveryReport, setOpenDeliveryReport] = useState(false);

  const onTrackDeliveryClick = () => {
    setOpenTrackDelivery(true);
  };

  const onDeliveryReportClick = () => {
    setOpenDeliveryReport(true);
  };

  const handleCloseTrackDelivery = () => {
    setOpenTrackDelivery(false);
  };

  const handleCloseDeliveryReport = () => {
    setOpenDeliveryReport(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        height: "100%",
        minHeight: "52px",
      }}
    >
      {/* Delivery Report Button */}
      <Box
        display="flex"
        alignItems="center"
        sx={{
          backgroundColor: "#FAFAFA",
          borderRadius: "6px",
          border: "1px solid #E0E0E0",
          padding: "4px 8px",
          gap: 1,
        }}
      >
        <Tooltip title="Delivery Report">
          <Box
            display="flex"
            alignItems="center"
            gap={0.5}
            sx={{
              cursor: "pointer",
              padding: "4px 8px",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#FFF3E0",
                borderColor: "#FFE0B2",
              },
            }}
            onClick={onDeliveryReportClick}
          >
            <LocalShippingIcon sx={{ color: "#F57C00" }} />
            <Typography
              variant="body2"
              sx={(theme) => ({
                ml: 1,
                fontSize: "13px",
                fontWeight: 500,
                color: "#F57C00",
              })}
            >
              Delivery Report
            </Typography>
          </Box>
        </Tooltip>
      </Box>
      {/* Track Delivery Button */}
      <Box
        display="flex"
        alignItems="center"
        sx={{
          backgroundColor: "#FAFAFA",
          borderRadius: "6px",
          border: "1px solid #E0E0E0",
          padding: "4px 8px",
          gap: 1,
        }}
      >
        <Tooltip title="Track Delivery">
          <Box
            display="flex"
            alignItems="center"
            gap={0.5}
            sx={{
              cursor: "pointer",

              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#E8F5E8",
                borderColor: "#C8E6C9",
              },
            }}
          >
            <Button
              startIcon={
                <LocalShippingIcon
                  sx={{
                    color:
                      params.row.driver_active_delivery == 1
                        ? "#388e3c"
                        : "#919191ff",
                  }}
                />
              }
              disabled={params.row.driver_active_delivery !== 1}
              sx={(theme) => ({
                ml: 1,
                fontSize: "12px",
                fontWeight: 500,
                color: "#388e3c",
              })}
              onClick={onTrackDeliveryClick}
            >
              Track Active Delivery
            </Button>
          </Box>
        </Tooltip>
      </Box>

      {/* Track Delivery Modal */}
      <Dialog
        open={openTrackDelivery}
        onClose={handleCloseTrackDelivery}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ bgcolor: "#f5f5f5" }}>
          Delivery Route Tracker
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <DriversReportTracker driverId={params.row.id} />
        </DialogContent>
        <DialogActions
          sx={{
            p: 2,
          }}
        >
          <Button
            onClick={handleCloseTrackDelivery}
            variant="contained"
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delivery Report Modal */}
      <Dialog
        open={openDeliveryReport}
        onClose={handleCloseDeliveryReport}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          style: {
            height: "90vh",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogTitle sx={{ bgcolor: "#f5f5f5" }}>
          Delivery Report
          {params.row.full_name && (
            <Chip
              icon={<PersonIcon />}
              label={`${params.row.full_name}`}
              variant="outlined"
              size="small"
              sx={{
                fontSize: "12px",
                height: "24px",
                ml: 2,
                "& .MuiChip-icon": {
                  fontSize: "16px",
                },
              }}
            />
          )}
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0, height: "100%" }}>
          <DeliveryReport
            driverId={params.row.id}
            driverName={params.row.full_name}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleCloseDeliveryReport}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ActionsCell;
